import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const DEFAULT_DIMENSIONS = {
  width: 300,
  height: 400
};

const useStyles = makeStyles(theme => ({
  popper: {
    zIndex: theme.zIndex.modal
  },
  popperPaper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    maxHeight: DEFAULT_DIMENSIONS.height,
    maxWidth: 'min-content',
    minWidth: DEFAULT_DIMENSIONS.width,
    overflowY: 'auto',
    padding: theme.spacing(2)
  }
}));

export const KeywordsChips = ({
  values,
  idKey = 'id',
  labelKey = 'label',
  maxVisible = 5,
  variant
}) => {
  const classes = useStyles();
  const iconButtonRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const visibleChips = values.slice(0, maxVisible);
  const hiddenChips = values.slice(maxVisible);

  const handleToggle = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {visibleChips.map(item => (
        <Chip
          key={item[idKey]}
          label={item[labelKey]}
          className="margin-right-bottom-1"
          size="small"
          variant={variant}
        />
      ))}

      {hiddenChips.length > 0 && (
        <>
          <IconButton ref={iconButtonRef} size="small" onClick={handleToggle}>
            <ArrowDropDownIcon />
          </IconButton>

          <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            className={classes.popper}
          >
            <ClickAwayListener onClickAway={handleClickAway}>
              <Paper className={classes.popperPaper} elevation={3}>
                {hiddenChips.map(item => (
                  <Chip
                    key={item[idKey]}
                    label={item[labelKey]}
                    className="margin-right-bottom-1"
                    size="small"
                    variant={variant}
                  />
                ))}
              </Paper>
            </ClickAwayListener>
          </Popper>
        </>
      )}
    </>
  );
};
